'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { LIVERAMP_PRELOAD_URL, LIVERAMP_SCRIPT_URL } from '../constants/dependency-urls';
import { logAdLifecycle, logAdLifecycleWarn } from '../utils/ad-lifecycle-log';
import { ensureScriptLoaded, injectPreloadLink } from '../utils/dependencies';
async function loadLiverampClientSide(): Promise<void> {
  logAdLifecycle('dependencies:start');
  injectPreloadLink(LIVERAMP_PRELOAD_URL);
  logAdLifecycle('liveramp:preload');
  try {
    await ensureScriptLoaded(LIVERAMP_SCRIPT_URL, {
      defer: true
    });
    logAdLifecycle('liveramp:loaded');
  } catch (error) {
    logAdLifecycleWarn('liveramp:failed', {
      message: String(error)
    });
  }
}
export function useEnsureLiverampReady(enabled, t0) {
  const $ = _c(6);
  const isServerRendered = t0 === undefined ? false : t0;
  const [isReady, setIsReady] = useState(false);
  let t1;
  let t2;
  if ($[0] !== enabled || $[1] !== isServerRendered) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      let cancelled = false;
      if (isServerRendered) {
        logAdLifecycle("dependencies:ready", {
          source: "server"
        });
        setIsReady(true);
        return;
      }
      loadLiverampClientSide().then(() => {
        if (!cancelled) {
          logAdLifecycle("dependencies:ready", {
            source: "client"
          });
          setIsReady(true);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [enabled, isServerRendered];
    $[0] = enabled;
    $[1] = isServerRendered;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isReady) {
    t3 = {
      isReady
    };
    $[4] = isReady;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}